var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('HomeContact')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("@/assets/images/contact.jpg")}})])
}]

export { render, staticRenderFns }